import { LearningPathStatus } from 'enum/learningPathStatus.enum'

export const initialLearningPathConfiguration = {
  id: 0,
  name: '',
  description: '',
  image: null,
  profiles: [],
  state: LearningPathStatus.draft,
}

export const initialLearningPathContent = {
  learningPaths: [0],
  collections: [
    {
      id: 0,
      name: 'Colección de cursos 1',
      order: 0,
      relatedCourses: [],
    },
  ],
}
